import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";

const BillDetailsModal = ({ open, onClose, billDetails }) => {
  const {
    supplierName,
    date,
    time,
    returnTableList,
    totalBill,
    amountPaid,
    paymentMode,
    payable,
    grantTotal,
  } = billDetails;

  const generateChallan = () => {
    const doc = new jsPDF();
    doc.setFont("Amiri", "normal");
    doc.setFontSize(12);
    doc.text(`Supplier Name: ${supplierName}`, 20, 30, { align: "left" });
    doc.text(`Date: ${date} ${time}`, 180, 30, { align: "right" });
  
    const tableColumn = ["Item", "Quantity", "Rate", "Total"];
    const tableRows = returnTableList.map((item) => [
      item.name || "No Name",
      item.quantity || 0,
      item.price || 0,
      item.totalAmount || 0,
    ]);
  
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      styles: {
        font: "Amiri",
        fontSize: 12,
        halign: "center",
      },
      headStyles: {
        fillColor: [211, 211, 211],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      columnStyles: {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "center" },
      },
    });
  
    const startY = doc.previousAutoTable.finalY + 10;

    const summaryTableRows = [
      ["Total Bill:", "", "", totalBill],
      ["Arrears:", "", "", payable],
      ["Grant Total:", "", "", grantTotal],
      ["Amount Paid:", "", "", amountPaid],
      ["Payment Method:", "", "", paymentMode],
    ];
  
    doc.autoTable({
      body: summaryTableRows,
      startY: startY,
      styles: {
        font: "Amiri",
        fontSize: 12,
        halign: "center",
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "left" },
        2: { halign: "left" },
        3: { halign: "center" },
      },
    });
  
    doc.save(`${supplierName} ${date}.pdf`);
  };
  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth dir="rtl">
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="h6" align="center">بل کی تفصیلات</Typography>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography fontWeight="bold">سپلائر کا نام: {supplierName}</Typography>
            <Typography fontWeight="bold">تاریخ: {date} {time}</Typography>
          </Box>
          <hr />
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="right" sx={{ padding: '4px' }}>آئٹم</TableCell>
                <TableCell align="right" sx={{ padding: '4px' }}>مقدار</TableCell>
                <TableCell align="right" sx={{ padding: '4px' }}>شرح</TableCell>
                <TableCell align="right" sx={{ padding: '4px' }}>کل</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {returnTableList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="right" sx={{ padding: '4px' }}>{item.name || "No Name"}</TableCell>
                  <TableCell align="right" sx={{ padding: '4px' }}>{item.quantity || 0}</TableCell>
                  <TableCell align="right" sx={{ padding: '4px' }}>{item.price || 0}</TableCell>
                  <TableCell align="right" sx={{ padding: '4px' }}>{item.totalAmount || 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Box mt={2}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell colSpan={2} align="right" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold"> ٹوٹل بل:</Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="center" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">{totalBill}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2} align="right" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">پچھلا بقایا :</Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="center" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">{payable}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2} align="right" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold"> آج کا ٹوٹل:</Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="center" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">{grantTotal}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2} align="right" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">ادا شدہ رقم:</Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="center" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">{amountPaid}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2} align="right" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">ادائیگی کا طریقہ:</Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="center" sx={{ padding: '4px' }}>
                    <Typography fontWeight="bold">{paymentMode}</Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button variant="contained" color="primary" onClick={generateChallan}>
              Download
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default BillDetailsModal;
